import KlarnaConnectMessage from './KlarnaConnectMessage';

export default KlarnaConnectMessage;
